module.exports = __webpack_public_path__ + "files/450d7ac830fa1707bfea5e1214b4a15b.png";